export default {
    methods: {
        getLanguage() {
            this.$api.$config.getCountry({}).then(res => res.Data.Result).then(res => {
                if (res.Info.type !== 1) {

                } else {

                    this.languageList = res.List
                }
            })
        },
    },
    data() {
        return {
            languageList: []
        }
    },

}